export const getRuntimeType = (state) => state.runtimeState.runtimeType;

export const getRuntimeStatus = (state) => state.runtimeState.status;

export const selectUserExecutorName = (state) => state.runtimeState.userExecutor?.name;
